module.exports = __webpack_public_path__ + "img/dfaf158fa324cf2949c04832bd43b698.png";